import { SkipSpinCommand } from "slotworks/commands/comms/skip-spin-command";
import Components from "slotworks/components/components";
import AbstractReelTransition from "slotworks/components/matrix/reel/transition-behaviours/abstract-reel-transition";
import { RemoveTransition } from "slotworks/components/matrix/reel/transition-behaviours/remove/remove-transition";
import GameState from "slotworks/model/game-state";
import Gameplay from "slotworks/model/gameplay/gameplay";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import settingsModel from "slotworks/model/settings/settings-model";
import State from "slotworks/state-machine/states/state";

export default class RemoveSymbols extends State {
    protected previousTransition: AbstractReelTransition;

    public onEnter(cascadeSkip?: boolean): void {
        this.updateRecordPointer();
        const spinRecord: SpinRecord = this.getRecord();
        this.previousTransition = Components.matrix.getTransition() as AbstractReelTransition;

        Components.matrix.setTransition(this.getTransition());
        Components.matrix.stopTransition(spinRecord, settingsModel.getQuickSpin()).then(() => this.complete());
    }

    public onSkip(cascaded?: boolean): void {
        const spinRecord: SpinRecord = this.getRecord();
        SkipSpinCommand(spinRecord).then(() => this.skip());
    }

    public onExit(): void {
        Components.matrix.setTransition(this.previousTransition);
    }

    protected getTransition() {
        return new RemoveTransition();
    }

    protected updateRecordPointer(): void {
        // ..
    }

    protected getRecord(): SpinRecord {
        const gameplay: Gameplay = GameState.getCurrentGame();
        let currentRecord: SpinRecord = gameplay.getCurrentRecord() as SpinRecord;
        if (!(currentRecord instanceof SpinRecord) && gameplay.getCurrentRecordParent() !== undefined) {
            currentRecord = gameplay.getCurrentRecordParent() as SpinRecord;
        }
        return currentRecord;
    }
}
